import { ref } from "vue"

export function useLogo() {
  const config = useRuntimeConfig()
  const s3Bucket = config.public.s3Bucket || "ldb-staging"
  const logoUrl = ref(`https://${s3Bucket}.s3.amazonaws.com/logo.svg`)
  const showFallback = ref(false)

  const handleError = () => {
    showFallback.value = true
  }

  return { logoUrl, showFallback, handleError }
}
